export default __webpack_public_path__ + "static/media/logout.429e92cc.svg";